module.exports = __webpack_public_path__ + "img/calendar_regular.1d2f8916.svg";